module.exports = __webpack_public_path__ + "static/media/discord.043d49a9.png";